import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import LocalStorage from 'src/utils/LocalStorage';
import { Pagination } from 'src/interfaces/general';

export type State = {
  loading: boolean;
  layoutSplit: string;
  me: Model.Me | null;
  pagination: Pagination;
};

const initialState: State = {
  loading: false,
  layoutSplit: '23%',
  me: LocalStorage.authInfo,
  pagination: {
    current_page: 0,
    item_from: 0,
    item_to: 0,
    limit: 0,
    next_page: 0,
    previous_page: 0,
    total_pages: 0,
    total_items: 0,
  },
};

const { reducer, actions } = createSlice({
  name: 'app',
  initialState,
  reducers: {
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    updateMe(state, action: PayloadAction<Model.Me>) {
      state.me = action.payload;
    },
    updatePagination(state, action: PayloadAction<Pagination>) {
      state.pagination = action.payload;
    },
  },
});

export { reducer };
export default actions;
